export default "__VITE_ASSET__DbiQk9yy__"